import React, { useState } from 'react';
import Loading from '../../../../Components/Loading';
import DocumentationFolderPicker from '../../../Documentation/Components/DocumentationFolderPicker/DocumentationFolderPicker';
import DocumentationFilePicker from '../../../Documentation/Components/DocumentationFilePicker/DocumentationFilePicker';
import styles from './DiscourseAttachDocument.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { useDiscourseContext } from '../../Services/DiscourseContext';
import { DocumentationFile } from '../../../../graphql/graphql';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	patientId: string;
}

const DiscourseAttachDocument: React.FC<Props> = ({ patientId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [selectedFolderId, setSelectedFolderId] = useState<string | undefined>(
		undefined,
	);
	const [showAllFiles, setShowAllFiles] = useState(false);
	const {
		handleAddCustomAttachmentToDiscourse,
		removeAttachmentFromDiscourse,
		discourseAttachments,
	} = useDiscourseContext();

	const handleAddFile = async (file: DocumentationFile) => {
		if (file.name && file.folderId) {
			await handleAddCustomAttachmentToDiscourse({
				attachmentId: file.id,
				type: 'documentationFile',
				attachmentTitle: file.name,
				sendToPatient: false,
				folderId: file.folderId,
				soft: true,
			});
		}
	};

	const handleRemoveFile = async (file: DocumentationFile) => {
		const attachment = discourseAttachments?.find(
			item => item.extra.id === file.id,
		);
		if (attachment) {
			await removeAttachmentFromDiscourse(attachment.id, true);
		}
	};

	const handleBackToFolderSelection = () => {
		setSelectedFolderId(undefined);
		setShowAllFiles(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	let component = (
		<>
			<div className={styles.button} onClick={() => setShowAllFiles(true)}>
				<img src={'/dist/icons/folder-solid.svg'} alt='Folder icon' />
				<Text tx='component.eCard.allFiles' />
			</div>
			<DocumentationFolderPicker
				patientId={patientId}
				onSelect={(id: string) => setSelectedFolderId(id)}
			/>
		</>
	);

	if (selectedFolderId || showAllFiles) {
		component = (
			<>
				<div className={styles.button} onClick={handleBackToFolderSelection}>
					<img src={'/dist/icons/share-solid.svg'} alt='Share icon' />
					<Text tx='component.eCard.backToFoldersList' />
				</div>
				<DocumentationFilePicker
					folderId={selectedFolderId}
					patientId={patientId}
					onAdd={handleAddFile}
					onRemove={handleRemoveFile}
				/>
			</>
		);
	}

	return (
		<div className={styles.wrapper}>
			<ScrollContainer>{component}</ScrollContainer>
		</div>
	);
};

export default DiscourseAttachDocument;
